import { useSetupCompletedMutation, useUpdateWorkspaceMutation } from '@/dealers/_gen/gql'
import Field from '@/gf/components/Field'
import StateList from '@/gf/components/StateList'
import { StateCode } from '@/types'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Frame from './Frame'
import { useSetupContext } from './context'

const TerritoryRestrictions = () => {
  const navigate = useNavigate()
  const { loading, storeId, store, refetch } = useSetupContext()
  const [updateWorkspaceMutation] = useUpdateWorkspaceMutation()
  const [setupCompleted] = useSetupCompletedMutation()
  const [rfqStates, setRfqStates] = useState<StateCode[]>([])
  const [updating, setUpdating] = useState(false)
  const [savingAndExiting, setSavingAndExiting] = useState(false)

  useEffect(() => {
    if (!loading) setRfqStates([...(store.rfqStates as StateCode[])].sort())
  }, [loading])

  const update = async () => {
    if (!store) return

    setUpdating(true)

    await updateWorkspaceMutation({
      variables: {
        storeId,
        rfqStates,
        brandIds: store.brands.map((b) => b.id),
        categoryIds: store.categories.map((c) => c.id),
      },
    })

    refetch()
  }

  const saveAndExit = async () => {
    setSavingAndExiting(true)
    await update()
    await setupCompleted({ variables: { storeId } })
    navigate('/dashboard')
    setSavingAndExiting(false)
  }

  const back = () => navigate('/setup/gearflow-supplier-network')

  const next = async () => {
    await update()
    navigate('/setup/parts')
  }

  return (
    <Frame
      className="space-y-6"
      progress={{ name: <>Territory Restrictions</>, mins: 4, className: 'w-3/5' }}
      savingAndExiting={savingAndExiting}
      nexting={updating}
      saveAndExit={saveAndExit}
      back={back}
      next={next}
    >
      <div className="space-y-4 max-w-md">
        <h2 className="text-2xl font-medium">Add your territory restrictions</h2>

        <p className="prose">
          First, add the restricted states you are able to sell into (if applicable). We will
          exclude your company from requests outside those states.
        </p>
      </div>

      <Field label="Restricted States">
        <StateList stateCodes={rfqStates} setStateCodes={setRfqStates} />
      </Field>
    </Frame>
  )
}

export default TerritoryRestrictions
